import React from "react";
import {
  Button,
  DropdownTrigger,
  Dropdown,
  DropdownMenu,
  DropdownItem,
} from "@heroui/react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { useTranslation } from "react-i18next";

import { VerticalDotsIcon } from "../orderList/VerticalDotsIcon";
import { FaRegTrashCan } from "react-icons/fa6";

export default function SecondaryActions( {user_id}) {
  const { t } = useTranslation();
  const axiosPrivate = useAxiosPrivate();

  const deleteUser = async () => {
    try {
      await axiosPrivate.delete(`/users/${user_id}`);
    } catch (error) {
      console.error(t("delete_user_error"), error);
    }
  };

  return (
    <div className="relative flex justify-end items-center gap-2">
      <Dropdown className="bg-background border-1 border-default-200">
        <DropdownTrigger>
          <Button isIconOnly radius="full" size="sm" variant="light">
            <VerticalDotsIcon className="text-default-400" width="24" height="24" />
          </Button>
        </DropdownTrigger>
        <DropdownMenu>
          <DropdownItem onClick={() => deleteUser()}>
            <div className="flex items-center gap-2">
              <FaRegTrashCan />
              {t("delete")}
            </div>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>
  );
}
